import { useContext } from 'react'

import { ListagemContext } from '@provider/FollowUpFornecedor/ListagemProvider'

import { IListagemContext } from '@base/@types/providers/FollowUpFornecedor/ListagemProvider'

export default function useFollowUpListagem(): IListagemContext {
  return useContext(ListagemContext)
}
